import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { createMap } from 'utils/map';

const Map = ({ zoom, center, onCreated, style }) => {
    const mapRef = useRef(null);
    const map = useRef(null);

    useEffect(() => {
        map.current = createMap(mapRef.current, zoom, center);
        onCreated(map.current);
        return () => {
            map.current?.remove();
            map.current = null;
        };
    }, [center, onCreated, zoom]);

    return <div ref={mapRef} style={style} />;
};

Map.propTypes = {
    zoom: PropTypes.number,
    center: PropTypes.arrayOf(PropTypes.number),
    onCreated: PropTypes.func,
    style: PropTypes.object
};

export default Map;
